<template>
  <div class="container">
		<div class="conmonContent">
			<div class="w1600">
				<keep-alive>
				<search search_type="version"></search>
				</keep-alive>
				 
				 <!-- 主体列表内容 -->
				 <div class="proPackage">
					 <div class="conmonDocument bd10">
						 <ul>
							 <li class="d-flex j-sb" v-for="(item, index) in versionList" :key="index">
								 <h3 class="font18 font-medium file h3"><a class="link" href="javascript:;" @click="goToPage('/productPackageDetail?id='+item.id)">{{item.name}}</a><span class="font-light">{{item.no}}</span></h3>
								 <span class="font-light cor999">{{item.releaseDate}}</span>
							 </li>
						 </ul>
					 </div>
					 <!-- 分页 -->
					 <div class="pagination">
						 <el-pagination
						       @current-change="handleCurrentChange"
						       :page-size="10"
						       layout="prev, pager, next"
						       :total="total">
						</el-pagination>
					 </div>
				 </div>
			</div>
		</div>
  </div>
</template>

<script>
// Search组件
import search from './component/search.vue';
export default {
  name: 'ProductPackage',
  components: {
    search
  },
  data() {
    return {
		// 安装包
		versionList: [],
		// 分页
		pagination: {
			contentType: 'version',
			pageNo: 1,
			pageSize: 10,
			productId: ''
		},
		// 数量
		total: 0
	}
  },
  
  created() {
	this.pagination.productId = this.$route.query.productId;
	// 获取安装包
	this.getVersionList();
  },
  
  methods: {
  	  // 页面跳转
  	  goToPage(path, query={}) {
  		  this.$router.push({
  		  	path,
  			query
  		  })
  	  },
	  
	  // 获取安装包
	  getVersionList() {
		  this.$axios.post(`product/otherPage`, this.pagination)
		  .then(res => {
			  let data = res.data;
			  this.versionList = data.list;
			  this.total = data.total;
		  })
		  .catch(err=>{})
	  },
	  
	  // 点击翻页
	  handleCurrentChange(current) {
		  this.pagination.pageNo = current;
		  // 更新
		  this.getDocumentVOList();
	  }
  }
}
</script>

<style lang="less" scoped>
	.conmonDocument{
		padding: .3rem;
		ul li{
			padding: .25rem 0;
			&:not(:last-child) {
				border-bottom: solid 1px #f1f1f1;
			}
			h3{
				width: 85%;
				min-height: 0.18rem;
				a{
					display: inline-block;
					vertical-align: middle;
				}
				span{
					padding-left: 10px;
					font-weight: normal;
					font-size: 0.8em;
					display: inline-block;
					vertical-align: middle;
				}
			}
		}
	}
</style>
